// @flow
const prefix_path = "leagues_draft";

export const createAPIEndpoints = ({ Private }: Object): Object => ({
	create: params => Private.post_multipart(`${prefix_path}/create`, params),
	update: params => Private.post_multipart(`${prefix_path}/update`, params),
	uploadAvatar: params =>
		Private.post(`${prefix_path}/upload_avatar`, params),
	show: params => Private.get(`${prefix_path}/show`, params),
	showMy: params => Private.get(`${prefix_path}/show_my`, params),
	showTeams: params => Private.get(`${prefix_path}/show_teams`, params),
	remove: params => Private.get(`${prefix_path}/remove`, params),
	regenerateList: params =>
		Private.get(`${prefix_path}/regenerate_list`, params),
	regenerateShow: params =>
		Private.get(`${prefix_path}/regenerate_show`, params),
	inviteTo: params => Private.post(`${prefix_path}/invite_to`, params),
	showToJoin: params => Private.get(`${prefix_path}/show_to_join`, params),
	joinTo: params => Private.get(`${prefix_path}/join_to`, params),
	leave: params => Private.get(`${prefix_path}/leave`, params),
	removeTeam: params => Private.get(`${prefix_path}/remove_team`, params),
	customDraftOrder: params =>
		Private.post(`${prefix_path}/custom_draft_order`, params),
	customScoring: params =>
		Private.post_multipart(`${prefix_path}/custom_scoring`, params),
	showOrder: params => Private.get(`${prefix_path}/show_order`, params),
	showCustomFullDraftOrder: params => Private.get(
		`${prefix_path}/show_custom_full_draft_order`
		, params),
	saveCustomFullDraftOrder: params => Private.post(
		`${prefix_path}/save_custom_full_draft_order`
		, params),
	waiverRequests: params =>
		Private.get(`${prefix_path}/waiver_requests`, params),
	waiverOrder: params => Private.get(`${prefix_path}/waiver_order`, params),
	waiverList: params => Private.get(`${prefix_path}/waiver_list`, params),
	waiverFree: params => Private.get(`${prefix_path}/waiver_free`, params),
	waiverHistory: params =>
		Private.get(`${prefix_path}/waiver_history`, params),
	ladder: params => Private.get(`${prefix_path}/ladder`, params),
	myList: params => Private.get(`${prefix_path}/my_list`, params),
	rankings: params => Private.get(`${prefix_path}/rankings`, params),
	rosters: params => Private.get(`${prefix_path}/rosters`, params),
	selectedPlayers: params =>
		Private.get(`${prefix_path}/selected_players`, params),
	draftHistory: params =>
		Private.get(`${prefix_path}/draft_history`, params),
	transactionHistory: params =>
		Private.get(`${prefix_path}/transaction_history`, params),
	server_time: () => Private.get(`${prefix_path}/server_time`),
	subscribe: params => Private.post("payment/league_subscribe", params),
	changeCoach: params => Private.post(`${prefix_path}/change_team_coach`, params),
	teamOverrideScores: params => Private.get(`${prefix_path}/team_override_scores`, params),
	updateTeamScores: params => Private.post(`${prefix_path}/update_team_scores`, params),
	saveKeeperDraftPicks: params => Private.post(`${prefix_path}/save_keeper_draft_picks`, params)
});

export default createAPIEndpoints;


// WEBPACK FOOTER //
// ./src/utils/api/leagueDraft/index.js